import React from "react";
import "./App.css";

export default function Footer() {
  return (
    <div className="footer">
      <a href="https://github.com/OlhaKrasnokutska/react-weather" target="_blank" rel="noreferrer">
        Open-source code
      </a>
      {" by Olya Krasnokutska"}
    </div>
  );
}
